import { useViewerQuery } from '~/generated/graphql'
import { DateTime } from 'luxon'
import { useCallback, useMemo, useState } from 'react'
import { AdGuidelineDialog } from './component'

export const useAdGuidelineDialog = () => {
  const [open, setOpen] = useState(true)
  const handleClose = useCallback(() => setOpen(false), [])
  const { loading, data } = useViewerQuery()

  const dialog = useMemo(() => {
    if (loading || !data) return null

    if (!data.viewer.adGuideline?.needAgree) return null

    return (
      <AdGuidelineDialog
        open={open}
        onClose={handleClose}
        url={data.viewer.adGuideline.url}
        latestVersion={DateTime.fromISO(data.viewer.adGuideline.latestVersion)}
      />
    )
  }, [loading, data, open, handleClose])

  const needAgree = !!data?.viewer.adGuideline?.needAgree
  return {
    needAgree,
    loading,
    dialog,
  }
}
